import { useState } from "react";
import './index.scss'
import { Product } from "components";
import { getProductsSelector } from "slices/products";
import { getCartSelector } from "slices/cart";
import { useAppSelector } from "store/hooks";

interface Props {
    title: string
    body: string
    discount?: boolean
    start: number
}

export function ProductList({ title, body, discount, start }: Props) {
    const products = useAppSelector(getProductsSelector)
    const cartItems = useAppSelector(getCartSelector)


    return (
        <div className="productListBg" id={discount ? 'discount' : ''}>
            <div className="max-width p-x mob-py-07 productList">
                <div className="productList-head">
                    <div className="productList-head__title">
                        {title}
                    </div>
                    <p className="productList-head__body">
                        {body}
                    </p>
                </div>
                <div className="productList-list">
                    {products.map(i => (
                        <Product product={i} id={`${discount ? 'discount' : 'non-discount'}-${i.id}`} key={`${discount ? 'discount' : 'non-discount'}-${i.id}`} cartIndex={cartItems.findIndex(cartitem => cartitem.id === `${discount ? 'discount' : 'non-discount'}-${i.id}`)} />
                    ))}
                </div>
            </div>
        </div>
    )
}